import { Dispatch, SetStateAction, useMemo, useState } from "react";
import { CalendarEvent } from "../../../utils/events";
import dayjs from "dayjs";

type UseEventModalReturn = {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  modalInfo: CalendarEvent | undefined;
  setModalInfo: Dispatch<SetStateAction<CalendarEvent | undefined>>;
};
export function useEventModal(): UseEventModalReturn {
  const [showModal, setShowModal] = useState(false);
  const [modalInfo, setModalInfo] = useState<CalendarEvent>();

  return { showModal, setShowModal, modalInfo, setModalInfo };
}

export function useWeekendEventDetection(events: CalendarEvent[]): boolean {
  return useMemo(() => {
    return events.some((event) => {
      if (event.noSchedule) return false;
      const localStart = dayjs(event.data.actualStart.local);
      const localEnd = dayjs(event.data.actualEnd.local);

      if (
        localStart.day() === 0 ||
        localStart.day() === 6 ||
        localEnd.day() === 0 ||
        localEnd.day() === 6
      ) {
        return true;
      }

      // Not the same day of the month, check if the event spans a weekend
      if (!localStart.isSame(localEnd, "day")) {
        // Need to check each day in between start and end date
        let currentDate = dayjs(event.data.actualStart.local);

        while (currentDate.isBefore(localEnd, "day")) {
          const dayOfWeek = currentDate.day();

          if (dayOfWeek === 0 || dayOfWeek === 6) {
            return true;
          }
          currentDate = currentDate.add(1, "day");
        }
      }

      return false;
    });
  }, [events]);
}
